import { DateFilterDialogComponent } from '../../dialogs/date-filter/date-filter.dialog';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DateFilterDialogService {

    constructor(public dialog: MatDialog) {}

    dateQuery: any = null;

    public open(callback: any) {
        let dialog = this.dialog.open(DateFilterDialogComponent, {
            width: '800px'
        });

        dialog.afterClosed().subscribe(r => {
            callback(this.dateQuery);
            this.dateQuery = null;
        })
    }

    public apply(dateQuery) {
        this.dateQuery = dateQuery;

        this.dialog.closeAll();
    }
}
